export default "__VITE_ASSET__xglfraNv__"